<template>
  <div class="ExpandItem">
    <button
      class="ExpandItem__button"
      :class="{ 'ExpandItem__button--active': internalOpen }"
      @click="onClick"
    >
      {{ openText }}
      <Icon iconName="Down" class="ExpandItem__icon" />
    </button>
    <div v-if="internalOpen" class="ExpandItem__inner">
      <slot />
    </div>
  </div>
</template>

<script>
import Icon from '@spectee/components/Atoms/IconBase/index.vue';

export default {
  name: 'ExpandItem',
  components: { Icon },
  props: {
    openText: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:isOpen'],
  data() {
    return {
      internalOpen: this.isOpen,
    };
  },
  watch: {
    isOpen(newVal) {
      this.internalOpen = newVal;
    },
  },
  methods: {
    onClick() {
      this.internalOpen = !this.internalOpen;
      this.$emit('update:isOpen', this.internalOpen);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.ExpandItem {
  &__button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: $service-unit * 4;
    font-size: $service-font-size-p;
    font-weight: bold;
    color: $color-gray-80;
    cursor: pointer;
    background-color: $color-gray-10;

    &:hover {
      background-color: $color-gray-30;
    }
  }

  & &__icon {
    flex-shrink: 0;
    width: $service-unit * 6;
    height: $service-unit * 6;
    margin-left: $service-unit;
    transition: 0.2s ease-out;
  }

  &__button--active &__icon {
    transform: rotate(180deg);
  }

  &__inner {
    padding: $service-unit * 4;
    font-size: $service-font-size-p;
    line-height: $service-line-height-mf;
  }
}
</style>
